<template>
  <div
    v-html="markdownHTML"
    class="md"
  />
</template>

<style>
@import '../../node_modules/highlight.js/styles/github-gist.css';
@import '../../node_modules/katex/dist/katex.css';

.md > h1 {
  font-size: 1.5em;
}

.md > h2 {
  font-size: 1.2em;
}

.md > h3 {
  font-size: 1.0em;
}

.md > p {
  margin: 1em;
}

.md > ul, .md > ol {
  margin: 1em;
}

.md pre code {
  display: block;
  margin: 1em;
  padding: 1em;
}

.md table {
  margin: 1em;
  color: #303030;
  width: auto;
  display: block;
  overflow-x: auto;
  border-collapse: collapse;
}

.md th, .md td {
  padding: 0.5em;
  border: 1px solid #dbdbdb;
}

.md th {
  background-color: #f0f0f0;
  border-bottom: solid 2px #bfbfbf;
}
</style>

<script>
import marked from 'marked'
import katex from 'katex'
import hljs from '@/common/my-highlight.js'

window.WaveSkin = require('wavedrom/skins/default.js');
var wavedromRenderAny = require('wavedrom/lib/render-any.js');
var wavedromCreateElement = require('wavedrom/lib/create-element.js');

const render = require('bit-field/lib/render');
const onml = require('onml');

var wavedromId = 0

const unescapeMap = {
  "&amp;": "&",
  "&quot;":'"',
  "&lt;": "<",
  "&gt;": ">",
  "&#39;": "'",
}
function unescapeHtml(html) {
  return html.replace(/&(lt|gt|amp|quot|#39);/g, match => unescapeMap[match])
}

const renderer = new marked.Renderer()
let originParagraph = renderer.paragraph.bind(renderer)
renderer.paragraph = (text) => {
  // WaveDrom
  {
    const wavedromRegex = /^\[\[\[wavedrom\s*\n([\s\S]*)\n\]\]\]/gm
    for (const match of text.matchAll(wavedromRegex)) {
      try {
        //console.log(unescapeHtml(match[1]))
        /* eslint-disable no-eval */
        //const source = eval('(' + unescapeHtml(match[1]) + ')')
        /* eslint-enable  no-eval */
        const source = JSON.parse(unescapeHtml(match[1]))
        const a = wavedromRenderAny(wavedromId, source, window.WaveSkin);
        const b = wavedromCreateElement(a)
        const html = b.outerHTML
        text = text.replace(match[0], html)
      } catch (e) {
        console.log(e)
      }
      wavedromId++
    }
  }

  // bit-field
  {
    const wavedromRegex = /^\[\[\[bit-?field\s*\n([\s\S]*)\n\]\]\]/gm
    for (const match of text.matchAll(wavedromRegex)) {
      try {
        const source = JSON.parse(unescapeHtml(match[1]))
        const jsonml = render(source.reg, source.options)
        const html = onml.stringify(jsonml)
        text = text.replace(match[0], html)
      } catch (e) {
        console.log(e)
      }
      wavedromId++
    }
  }

  const blockRegex = /\$\$[^$]*\$\$/g
  const inlineRegex = /\$[^$]*\$/g
  let blockExprArray = text.match(blockRegex)
  let inlineExprArray = text.match(inlineRegex)
  for (let i in blockExprArray) {
    const expr = blockExprArray[i]
    const result = renderMathsExpression(expr)
    text = text.replace(expr, result)
  }
  for (let i in inlineExprArray) {
    const expr = inlineExprArray[i]
    const result = renderMathsExpression(expr)
    text = text.replace(expr, result)
  }
  return originParagraph(text)
}

function renderMathsExpression(expr) {
  if (expr[0] === '$' && expr[expr.length - 1] === '$') {
    let displayStyle = false
    expr = expr.substr(1, expr.length - 2)
    if (expr[0] === '$' && expr[expr.length - 1] === '$') {
      displayStyle = true
      expr = expr.substr(1, expr.length - 2)
    }
    let html = null
    try {
      html = katex.renderToString(expr)
    } catch (e) {
      console.log(e)
    }
    if (displayStyle && html) {
      html = html.replace(/class="katex"/g, 'class="katex katex-block" style="display: block;"')
    }
    return html
  } else {
    return null
  }
}

marked.setOptions({
  renderer: renderer,
  highlight: function(code, lang) {
    return hljs.highlightAuto(code, [lang]).value
  }
})

export default {
  props: ['markdownText'], 
  computed: {
    markdownHTML() {
      return marked(this.markdownText)
    },
  },
};
</script>


